module.exports = __webpack_public_path__ + "img/mb-step-3.099de248.png";